import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { ICredentials, ILoginResponse } from 'src/app/shared/interfaces/credentials/credentials';
import { IUser } from 'src/app/shared/interfaces/user/user';

const AUTH_ENDPOINT = 'auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private user$ = new BehaviorSubject<IUser | undefined>(undefined);

  getUserLogged$(): Observable<IUser | undefined> {
    return this.user$.asObservable();
  }

  setUserLogged$(user: IUser | undefined) {
    this.user$.next(user);
  }

  constructor(private httpClient: HttpClient) { }

  login(credentials: ICredentials) {
    return this.httpClient.post(`${environment.claroApiUrl}${AUTH_ENDPOINT}/${environment.actions.login}`, credentials).pipe(
      map((res) => {
        let response = res as ILoginResponse;
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('user_roles', JSON.stringify(response.user?.roles || []));
        return response;
      })
    );
  }

  superAdminLogin(credentials: ICredentials) {
    return this.httpClient.post(`${environment.claroApiUrl}super-admin/auth/login`, credentials).pipe(
      map((res) => {
        let response = res as ILoginResponse;
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('user_roles', JSON.stringify(response.user?.roles || []));
        return response;
      })
    );
  }

  getAccesToken() {
    return localStorage.getItem('access_token');
  }

  getUserRoles(): string[] {
    try {
      return JSON.parse(localStorage.getItem('user_roles') || '[]');
    } catch {
      return [];
    }
  }

  refreshToken() {
    return this.httpClient.post(`${environment.claroApiUrl}${AUTH_ENDPOINT}/${environment.actions.refresh}`, {}).pipe(
      map((res: any) => {
        localStorage.setItem('access_token', res.access_token);
        return res;
      })
    );
  }

  getUserLoggedData() {
    return this.httpClient.post(`${environment.claroApiUrl}${AUTH_ENDPOINT}/${environment.actions.me}`, {});
  }

  getSuperAdminProfile() {
    return this.httpClient.get(`${environment.claroApiUrl}super-admin/auth/me`);
  }

  forgotPassword(email: string) {
    return this.httpClient.post(`${environment.claroApiUrl}${AUTH_ENDPOINT}/${environment.actions.forgotPassword}`, { email });
  }

  updatePassword(data: { password: string; password_confirmation: string }) {
    return this.httpClient.post(`${environment.claroApiUrl}${AUTH_ENDPOINT}/${environment.actions.updatePassword}`, data);
  }

  completeProfile(data: { area: string; puesto: string; pais: string }) {
    return this.httpClient.post(`${environment.claroApiUrl}${AUTH_ENDPOINT}/${environment.actions.completeProfile}`, data);
  }

}
